<template>
    <client-page class="wrap wrap--sub">
        <sub-visual visual="시설·장비예약"></sub-visual>
        <!-- <sub-visual :visual="title" class="sv1"></sub-visual> -->
        <rental-navigation-row />

        <section class="section" id="retnal-subject-list-section">
            <v-container>
                <rental-subject-filter/>

                <rental-subject-card v-for="item in subjects" :key="item?._id" v-bind="{ item }" class="mt-60" />

                <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-60 mb-60" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { RENTAL_SUBJECT_TYPES } from "@/assets/variables";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import RentalSubjectCard from "@/components/client/rental/rental-subject-card.vue";
import RentalSubjectFilter from "@/components/client/rental/rental-subject-filter.vue";
import RentalNavigationRow from "@/components/client/rental/rental-navigation-row.vue";

const defaultType = RENTAL_SUBJECT_TYPES.EQUIPMENTS.value.toLowerCase();

export default {
    components: {
        SubVisual,
        ClientPage,
        RentalSubjectCard,
        RentalSubjectFilter,
        RentalNavigationRow,
    },
    props: {
        type: { type: String, default: defaultType },
    },
    data: () => ({
        subjects: [],

        limit: 10,
        summary: { totalCount: 0 },
    }),
    computed: {
        // title() {
        //     return `${RENTAL_SUBJECT_TYPES[this.type.toUpperCase()]?.text || ""}예약`;
        // },
        page() {
            return +(this.$route.query.page || "1");
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        headers() {
            let { limit } = this;
            return { skip: (this.page - 1) * limit, limit };
        },
        params() {
            let { query } = this.$route;
            let type = this.type?.toUpperCase?.();

            return { ...query, type, shows: true };
        },
    },
    mounted() {
        this.reroute().then(this.search);
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async reroute() {
            if (!Object.keys(RENTAL_SUBJECT_TYPES).includes(this.type?.toUpperCase?.())) {
                const path = `/rental/${defaultType}`;
                if (this.$route.path !== path) this.$router.replace({ path });
            }
        },
        async search() {
            let { headers, params } = this;
            let { summary, subjects } = await api.v1.rental.subjects.gets({ headers, params });
            this.summary = summary;
            this.subjects = subjects;

            document.getElementById("retnal-subject-list-section").scrollIntoView({ behavior: "smooth" });
        },
    },
};
</script>
